import React, { FC, useState } from 'react';
import { Tabs } from 'antd';
import { RichTextEditor } from '@mantine/rte';
import {
  DEFAULT_LANGUAGE,
  Language,
  LANGUAGES,
  LocalizedText,
} from 'apollo/localizedTypes';
import languageLabels from 'utils/i18n/languageLabels';
import styles from './LocalizedRichTextInput.module.scss';

export interface LocalizedRichTextInputProps {
  value?: LocalizedText;
  onChange?: (value: LocalizedText) => void;
}

export const LocalizedRichTextInput: FC<LocalizedRichTextInputProps> = ({
  value,
  onChange,
}: LocalizedRichTextInputProps) => {
  const [activeLanguage, setActiveLanguage] = useState<Language>(DEFAULT_LANGUAGE);
  const { TabPane } = Tabs;

  const onEditorChange = (language: Language, text: string) => {
    onChange?.({
      ...value,
      [DEFAULT_LANGUAGE]: value?.[DEFAULT_LANGUAGE] || '',
      [language]: text,
    });
  };

  return (
    <div className={styles.Panel}>
      <Tabs
        className={styles.Tabs}
        activeKey={activeLanguage}
        onChange={(key) => setActiveLanguage(key as Language)}
      >
        {LANGUAGES.map((language) => (
          <TabPane tab={languageLabels[language]} key={language} />
        ))}
      </Tabs>
      {LANGUAGES.map((language) => (
        <div
          key={language}
          className={language === activeLanguage ? undefined : styles.Hidden}
        >
          <RichTextEditor
            value={value?.[language] || ''}
            onChange={(text) => onEditorChange(language, text)}
          />
        </div>
      ))}
    </div>
  );
};

LocalizedRichTextInput.defaultProps = {
  value: undefined,
  onChange: undefined,
};

export default LocalizedRichTextInput;
